// Only these exact domains should be indexed
const INDEXABLE_DOMAINS = ["www.placement.com", "www.exec.com"];

/**
 * Determines if the current page should be indexed by search engines
 */
export function shouldIndex(req?: { headers?: { host?: string } }): boolean {
  // Server-side: check request host header
  if (typeof window === "undefined") {
    if (!req?.headers?.host) return true; // Can't determine, safer not to add noindex
    const domain = req.headers.host.split(":")[0].trim(); // Remove port if present
    return INDEXABLE_DOMAINS.includes(domain);
  }

  // Client-side: check window location
  return INDEXABLE_DOMAINS.includes(window.location.hostname);
}
